import * as React from 'react';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Box, FormControl, Grid, RadioGroup, FormControlLabel, Radio, FormLabel, Divider, Checkbox, Stack, Switch } from "@mui/material";
import moment from 'moment';

export default function AddTenantsFromUnoccupiedForm({ handleChangeTenantNumber, errors, unit, isBrandNewTenant, handleChangeTenantType, tenant, 
  loadedTenant, isExistingTenant, loadingTenantsError, handleChangeTenantDetails, calculatedValues, handleChangePeriodsCovered, handleChangeSecurityDeposit, 
  hasPaymentBacklog, handleHasPaymentBacklog, handleChangeIsInitialPaymentMade, isOutstandingBalance,handleChangeBalanceType, isInitialPaymentMade }) {
  
  return (
    <Grid container component="form" sx={{ "& .MuiTextField-root": { m: 1, width: "100%" } }} noValidate autoComplete="off" > 
      <Grid>
        <Typography component="div"> Property Name:{" "} <b>{unit.related_rental_unit.related_rental.rental_name}</b> </Typography>
        <Typography component="div"> Unit Selected:{" "} <b>{unit.related_rental_unit.unit_name}</b> </Typography>
      </Grid>

      <Typography variant="h6" component="div" sx={{ marginTop: "10px" }}>Enter the Tenants Phone number starting with 256, for example 256770123456{" "} </Typography>
      <Grid item xs={6} spacing={2} sx={{ marginTop: 2 }}>
        <TextField
          required
          id="outlined-required"
          label="Tenants Phone Number"
          onChange={handleChangeTenantNumber}
          fullWidth={true}
          name="phone_number"
          margin="dense"
          type="number"
          autoFocus
          error={Boolean(errors.phone_number)}
          helperText={errors.phone_number}
        />
      </Grid>
      {loadingTenantsError && (
        <Typography variant="h6" component="div" sx={{ color: "red" }}>
          {loadingTenantsError}
        </Typography>
      )}

      {loadedTenant ? (
        <Grid item xs={12} spacing={2} sx={{ marginTop: 1 }}>
          <Card variant="outlined" sx={{ minWidth: 100 }}>
            <CardContent>
              <Typography variant="h5" component="div"> Tenant Name: {tenant.first_name} {tenant.last_name} </Typography>
              <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom > Tenant Contact: +256{tenant.phone_number} </Typography>
              <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom > Tenant Number: {tenant.tenant_number} </Typography>
            </CardContent>
          </Card>
        </Grid>
      ) : (
        <></>
      )}

      {!isExistingTenant && (
        <Grid item xs={12} spacing={2} sx={{ marginTop: 1 }}>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <TextField
              required
              id="outlined-required"
              label="First Name"
              onChange={handleChangeTenantDetails}
              fullWidth={true}
              name="first_name"
              error={Boolean(errors.first_name)}
              helperText={errors.first_name}
              margin="dense"
              autoFocus
            />
            <TextField
              required
              id="outlined-required"
              label="Last Name"
              onChange={handleChangeTenantDetails}
              fullWidth={true}
              name="last_name"
              error={Boolean(errors.last_name)}
              helperText={errors.last_name}
              margin="dense"
            />
          </Box>
        </Grid>
      )}

      <Grid item xs={12} spacing={2} sx={{ marginTop: 2 }}>
        {(loadedTenant || !isExistingTenant) && (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <TextField
                label="Unit Rent"
                disabled
                size="small"
                defaultValue={unit.unit_rent}
                name="next_payment_date"
              />
              <TextField
                label="Expected Initial Deposit"
                disabled
                size="small"
                defaultValue={unit.unit_cycle_down_payment}
                name="next_payment_date"
              />
              <TextField
                label="Expected Security Deposit"
                disabled
                size="small"
                defaultValue={unit.unit_rent_security_fee}
                name="next_payment_date"
              />
            </Box>

            <FormControl sx={{ margin: 2 }}>
              <FormLabel>
                <Typography color="red">
                  *Select if the tenant is new or was already occupying the unit
                </Typography>
              </FormLabel>
              <RadioGroup row>
                <FormControlLabel
                  value={true}
                  control={
                    <Radio
                      checked={isBrandNewTenant === true}
                      onChange={() => handleChangeTenantType(true)}
                    />
                  }
                  label="Brand New Tenant in Unit"
                />
                <FormControlLabel
                  value={false}
                  control={
                    <Radio
                      checked={isBrandNewTenant == false}
                      onChange={() => handleChangeTenantType(false)}
                    />
                  }
                  label="Pre-existing Tenant in Unit"
                />
              </RadioGroup>
            </FormControl>
            {isBrandNewTenant && (
              <>
                <Grid container spacing={1} sx={{ m: "2px 0 2px", display: "flex", alignItems: "center" }} >
                  <Grid item xs={12} md={6}>
                    <Typography>
                      Date when tenant will occupy the unit:
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      label="Starting Date"
                      type="date"
                      size="small"
                      defaultValue={moment().format("YYYY-MM-DD")}
                      name="start_date"
                      onChange={handleChangeTenantDetails}
                      error={Boolean(errors.start_date)}
                      helperText={errors.start_date}
                    />
                  </Grid>
                </Grid>
                <Divider />
                <Grid container spacing={1} sx={{ m: "2px 0 2px", display: "flex", alignItems: "center" }}>
                  <Grid item xs={3}>
                    <Typography>Initial Deposit:</Typography>
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <TextField
                      required
                      id="periods_covered_initially"
                      size="small"
                      label="Periods Covered"
                      onChange={handleChangePeriodsCovered}
                      error={Boolean(errors.periods_covered_initially)}
                      name="periods_covered_initially"
                      defaultValue={unit.down_payment_periods_covered}
                      helperText={errors.periods_covered_initially}
                      type="number"
                      margin="dense"
                    />
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <TextField
                      disabled
                      size="small"
                      label="Amount"
                      value={calculatedValues.rent_amount_paid}
                      type="number"
                      margin="dense"
                    />
                  </Grid>
                </Grid>
                <Divider />
                <Grid container spacing={1} sx={{ m: "2px 0 2px", display: "flex", alignItems: "center" }}>
                  <Grid item xs={12} md={3}>
                    <Typography>Security Deposit:</Typography>
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <TextField
                      required
                      id="security_deposit_amount"
                      label="Amount"
                      size="small"
                      onChange={handleChangeSecurityDeposit}
                      error={Boolean(errors.securitry_deposit_amount)}
                      name="securitry_deposit_amount"
                      defaultValue={unit.unit_rent_security_fee}
                      helperText={errors.securitry_deposit_amount}
                      type="number"
                      margin="dense"
                    />
                  </Grid>
                </Grid>
                <Divider />
                <Grid container spacing={1} sx={{ m: "2px 0 2px", display: "flex", alignItems: "center" }}>
                  <Grid item xs={12} md={3}>
                    <Typography fontWeight="bold">Total Amount Expected:</Typography>
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <TextField
                      disabled
                      id="months-covered"
                      label="Amount"
                      size="small"
                      value={calculatedValues.total_deposit_amount}
                      name="securitry_deposit_amount"
                      type="number"
                      margin="dense"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                      <Typography>Is this amount already paid? No</Typography>
                      <Switch color="success" name="is_initial_payment_made" onChange={handleChangeIsInitialPaymentMade}/>
                      <Typography>Yes</Typography>
                    </Stack>
                  </Grid>
                  {!isInitialPaymentMade && 
                    <>
                      <Grid item xs={12} md={7}>
                        <Typography>
                          When do you expect payment to be made?:
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextField
                          label="Expected Payment Date"
                          type="date"
                          size="small"
                          defaultValue={moment().format("YYYY-MM-DD")}
                          inputProps={{ min: moment().add(1, 'day').format('YYYY-MM-DD') }}
                          name="expected_payment_date"
                          onChange={handleChangeTenantDetails}
                          error={Boolean(errors.expected_payment_date)}
                          helperText={errors.expected_payment_date}
                        />
                      </Grid>
                    </>
                  }
                </Grid>
              </>
            )}
            {!isBrandNewTenant && (
              <>
                <Grid container spacing={1} sx={{ mb: "2px", display: "flex", alignItems: "center" }}>
                  <Grid item xs={12}>
                    <Typography>Next Payment Date</Typography>
                  </Grid>
                  <Grid item xs={12} md={5}>
                    <TextField
                      label="Next Payment Date"
                      type="date"
                      size="small"
                      defaultValue={moment().add(1, 'day').format('YYYY-MM-DD')}
                      inputProps={{ min: moment().add(1, 'day').format('YYYY-MM-DD') }}
                      name="next_payment_date"
                      onChange={handleChangeTenantDetails}
                      error={Boolean(errors.next_payment_date)}
                      helperText={errors.next_payment_date}
                    />
                  </Grid>
                </Grid>
                <Divider />

                
                  <Grid container spacing={1} sx={{ mb: "2px", display: "flex", alignItems: "center" }}>
                    <Grid item xs={12}>
                      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                        <Typography>Does the tenant have any balances? No</Typography>
                        <Switch color="success" onChange={handleHasPaymentBacklog}/>
                        <Typography>Yes</Typography>
                      </Stack>
                    </Grid>
                    {hasPaymentBacklog &&
                      <>
                        <Grid item xs={12} md={6}>
                          <Stack>
                            {/* <Typography>Outstanding Balance(They owe us):</Typography> */}
                            <FormControlLabel
                              value={true}
                              sx={{ marginLeft:"5px" }}
                              control={
                                <Radio
                                  checked={isOutstandingBalance === true}
                                  onChange={() => handleChangeBalanceType(true)}
                                />
                              }
                              label="Outstanding Balance:"
                            />
                          
                            {isOutstandingBalance &&
                            <TextField
                              required
                              id="rent_backlog_amount"
                              size="small"
                              label="Outstanding Balance"
                              onChange={handleChangeTenantDetails}
                              name="rent_backlog_amount"
                              inputProps={{ min: 0 }}
                              defaultValue={0}
                              value={calculatedValues.rent_backlog_amount}
                              error={Boolean(errors.rent_backlog_amount)}
                              helperText={errors.rent_backlog_amount}
                              type="number"
                              margin="dense"
                            />}
                          </Stack>
                        </Grid>
                        <Divider className='desktop-only'/>
                        <Grid item xs={12} md={6}>
                          <Stack>
                            <FormControlLabel
                              value={false}
                              sx={{ marginLeft:"5px" }}
                              control={
                                <Radio
                                  checked={isOutstandingBalance === false}
                                  onChange={() => handleChangeBalanceType(false)}
                                />
                              }
                              label="Balance Carried Forward"
                            />
                            {!isOutstandingBalance &&
                            <TextField
                              required
                              id="rent_backlog_amount"
                              size="small"
                              label="Balance Carried Forward"
                              onChange={handleChangeTenantDetails}
                              name="rent_backlog_amount"
                              inputProps={{ min: 0 }}
                              defaultValue={0}
                              value={calculatedValues.rent_backlog_amount}
                              error={Boolean(errors.rent_backlog_amount)}
                              helperText={errors.rent_backlog_amount}
                              type="number"
                              margin="dense"
                            />}
                          </Stack>
                        </Grid>
                        
                        <Grid item xs={12} md={12}>
                          <Typography sx={{ marginLeft:"5px" }}>Description of Balance</Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <TextField
                            required
                            id="rent_backlog_amount"
                            size="small"
                            multiline
                            rows={2}
                            label="Description of Balance"
                            onChange={handleChangeTenantDetails}
                            name="rent_backlog_description"
                            margin="dense"
                          />
                        </Grid>
                      </>
                    }
                </Grid>
              </>
            )}
          </Box>
        )}
      </Grid>
    </Grid>
  );
}